import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useExpiredSubscriptionModalStore = create(
  persist(
    (set) => ({
      modalClosed: false,
      setModalClosed: (modalClosed) => set({ modalClosed }),
    }),
    {
      name: 'expired-trial-modal',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
